import {
  DrawerHeader,
  DrawerOverline,
  Flex,
  VStack,
  Text,
  DrawerCloseButton,
} from '@frontend/components';

type FormHeaderProps = {
  isLinearNest: boolean;
};

export const FormHeader = ({ isLinearNest }: FormHeaderProps) => {
  return (
    <DrawerHeader>
      <Flex
        justifyContent={'space-between'}
        alignItems={'center'}
        width={'100%'}
      >
        <DrawerOverline>MULTI-COMPONENT NESTING</DrawerOverline>
        <DrawerCloseButton />
      </Flex>
      <VStack alignItems={'flex-start'}>
        <Text fontWeight={'heavy'} fontSize={'lg'}>
          Update {isLinearNest ? 'Linear' : 'Sheet Metal'} Nesting Defaults
        </Text>
        <Text
          position="relative"
          pl="0.6875rem"
          _before={{
            content: `'_'`,
            color: 'transparent',
            bg: 'brand.secondary',
            position: 'absolute',
            top: '0.125rem',
            bottom: '0.125rem',
            left: 0,
            w: '0.1875rem',
          }}
        >
          Defaults apply to new nests
        </Text>
      </VStack>
    </DrawerHeader>
  );
};
